package net.bothosting.docs.components.widgets

data class NavSection(val title: String, val items: List<NavItem>, val icon: String = "fa-book")
data class NavItem(val title: String, val path: String, val icon: String = "fa-file-lines")
